import { ColHTMLAttributes } from 'react'
import styled, { css } from 'styled-components'
import { media } from '../GlobalStyle'

type ITableStyled = {
  bordered?: boolean
  $altheaderstyle?: boolean
  stripes?: boolean
}

interface ColProps extends ColHTMLAttributes<HTMLTableColElement> {
  headwidth?: string
  $hidemobile?: boolean
}

export const TableWrapper = styled.div`
  overflow-x: auto;
  max-height: 500px;
`

const stripes = css`
  tr:nth-child(even) {
    background-color: ${(props) => props.theme.table.stripe};
  }
`

const headerStyle = css`
  tr td,
  tr th {
    background-color: ${(props) => props.theme.table.bgColor};
    border-radius: 6px 6px 0 0;
    font-weight: 600;
    color: ${(props) => props.theme.body.textColor};
  }
`

const alternateHeaderStyle = css`
  background-color: transparent;

  td {
    padding: 8px 12px;
    font-size: 0.85em;
    color: ${(props) => props.theme.body.textMuted};
  }
`

export const Column = styled.td<ColProps>`
  padding: 12px 14px;
  min-width: ${(props) => (props.headwidth ? props.headwidth : 'auto')};
  display: ${(props) => (props.$hidemobile ? 'none' : 'table-cell')};
  text-align: ${(props) => (props.align ? props.align : 'left')};

  ${media.small} {
    display: table-cell;
  }
`
export const TableStyled = styled.table<ITableStyled>`
  border-collapse: collapse;
  border-spacing: 0;
  width: 100%;
  font-size: 0.95em;

  thead {
    ${(props) => (props.$altheaderstyle ? alternateHeaderStyle : headerStyle)};
  }

  tbody {
    ${(props) =>
      props.$altheaderstyle
        ? `tr:first-child {
            border-radius: 6px 6px 0 0;    
          }`
        : ''}

    tr {
      overflow: hidden;
      background-color: ${(props) => props.theme.table.bgColor};
      ${(props) =>
        props.bordered
          ? `&:not(:last-child) {
            border-bottom: 1px solid #efefef;
          }`
          : ''}

      &:hover {
        background-color: ${(props) => props.theme.table.hover};
      }
    }
  }

  ${(props) => (props.stripes ? stripes : '')}
`

export const ClickableRow = styled.tr`
  cursor: pointer;
`
